import { makeAutoObservable } from 'mobx'
import { type IUser } from '../server/user/get'
import { jwtDecode } from 'jwt-decode'

const DEFAULT_DATA = (): IUser => ({
  id: '',
  avatarUrl: '',
  name: '',
  secondName: '',
  lastName: '',
  role: '',
  balls: 0,
  coins: 0,
  phone: '',
  email: '',
  telegram: '',
  snils: '',
  gender: '',
  birthday: '',
  foreignCitizen: false,
  hasOrganization: false,
  socials: [],
  showPhone: true,
  canAddEvents:false,
  showEmail: true})

class _UserStore {
  data: IUser = DEFAULT_DATA()

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  updateUserData(): void {
    const token = localStorage.getItem('token')
    if (!token) return

    const data: IUser = jwtDecode(token)

    const _data: any = Object.keys(data).reduce((acc: any, key) => {
      const _key = key as keyof IUser

      if (typeof this.data[_key] !== 'undefined') {
        acc[_key] = data[_key]
      }

      return acc
    }, {})

    this.data = { ...this.data, ..._data }
  }

  clearUserData(): void {
    this.data = DEFAULT_DATA()
  }
}

const UserStore = new _UserStore()

export { UserStore }
